"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function vdlPrefix(className) {
    if (process.env.VDL_PREFIX == null) {
        return 'vdl-' + className;
    }
    else {
        return process.env.VDL_PREFIX + className;
    }
}
exports.vdlPrefix = vdlPrefix;



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/util/vdl-prefix.js
// module id = 4
// module chunks = 0 1 2 3 4 5 6